import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import Icon from "../components/Icon";
import Gallery from "../components/Gallery";
import products from "../data/products";
import "../styles/GalleryPage.css";

// Full-site Gallery page — every product photo in one modern bento
// grid, no category filters. Click any photo to open the full-size
// overview (lightbox).
export default function GalleryPage() {
  // products.js uses { name, image } — Gallery expects { title, image },
  // so map once here.
  const galleryItems = useMemo(
    () =>
      products.map((product) => ({
        id: product.id,
        title: product.name,
        image: product.image,
      })),
    []
  );

  return (
    <div className="tp-gallery-page">
      <section className="tp-gallery-page__hero tp-floral-bg2">
        <div className="tp-container">
          <span className="tp-eyebrow">Terra Bloom Studio</span>
          <h1 className="tp-section-heading">Our Full Gallery</h1>
          <p className="tp-section-sub">
            Every piece we've handcrafted from Kerala's natural waste — tap any photo for a
            closer look.
          </p>
        </div>
      </section>

      <Gallery
        items={galleryItems}
        eyebrow="Browse The Collection"
        heading={`Handcrafted Pieces`}
        sub="Click on any photo to open a full-size overview."
        seeAllPath={null}
      />

      <section className="tp-gallery-page__cta">
        <div className="tp-container tp-gallery-page__cta-inner">
          <div>
            <h2>Like something you see?</h2>
            <p>Request a personalised quote for bulk orders, custom colours, or gifting sets.</p>
          </div>
          <Link to="/request-quote" className="tp-btn tp-btn--primary">
            Request a Quote
            <Icon name="arrow" size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
